import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ServiceAreaAndTrust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}